<template>
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :show-close="true"
    :title="$t('home.exportPicture')"
    :visible.sync="dialogVisibleExport"
    top="10vh"
    width="500px"
    @close="clearForm"
  >
    <el-form
      ref="exportRuleForm"
      :model="exportRuleForm"
      class="demo-exportRuleForm"
      label-position="top"
    >
      <el-form-item
        :rules="{
          required: true,
          message: $t('placeOrder.pleaseInput'),
          trigger: ['blur', 'change']
        }"
        prop="NumberType"
      >
        <el-select v-model="exportRuleForm.NumberType" style="width: 60%">
          <!--运单号-->
          <el-option key="1" :label="$t('orderCenterCont.anjunWaybillNumber')" :value="1" />
          <!--扫描单号-->
          <el-option key="2" :label="$t('GlobalSetObj.ScanNumber')" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item
        :rules="{
          required: true,
          message: $t('placeOrder.pleaseInput'),
          trigger: ['blur']
        }"
        prop="inputValeu"
        style="width: 100%"
      >
        <el-input
          v-model="exportRuleForm.inputValeu"
          :placeholder="$t('orderCenterCont.Multiple')"
          clearable
          rows="6"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <div style="text-align: right; margin: 15px 0">
      <el-button
        size="small" @click="dialogVisibleExport = false"
      >{{ $t('GlobalSetObj.Cancelar') }}
      </el-button>
      <el-button
        size="small" type="primary" @click="comfireExport"
      >{{ $t('collectionCenter.CheckItOutNow') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { complaintWorkOrderexportImage } from '@/api/newExpressAPI';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'OrderNumberExport',
  data() {
    return {
      dialogVisibleExport: false,
      exportRuleForm: {
        NumberType: 1,
        inputValeu: ''
      }
    };
  },
  methods: {
    handleOpen() {
      this.dialogVisibleExport = true;
    },
    clearForm() {
      this.exportRuleForm.NumberType = 1;
      this.exportRuleForm.inputValeu = '';
    },
    comfireExport() {
      this.$refs['exportRuleForm'].validate((valid) => {
        if (valid) {
          const numberList = this.exportRuleForm.inputValeu
            ? this.exportRuleForm.inputValeu.split('\n')
            : [];
          const numList = numberList.filter((item) => item !== '');
          if (numList.length > 1000) {
            this.$message.error(this.$t('fixDutyFine.maxExportLimit'));
            return;
          }
          const param = {
            numberType: this.exportRuleForm.NumberType,
            numberList: numList
          };
          complaintWorkOrderexportImage(param).then(() => {
            this.dialogVisibleExport = false;
            goResourceTaskList();
          });
          console.log(param, 'param');
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped></style>
